<div *ngIf="schema" [ngSwitch]="schema.type">
	<workflow-object-renderer *ngSwitchCase="'object'" [property]="property" [schema]="resolvedSchema" [data]="data"
							[required]="required"></workflow-object-renderer>
	<workflow-string-renderer *ngSwitchCase="'string'" [property]="property" [schema]="resolvedSchema" [data]="data"
							[required]="required"></workflow-string-renderer>
	<div *ngSwitchDefault>{{schema.type}}</div>
</div>
